import { MeasureMassif } from '../../domain/Massif/measure-massif';
import { mapper } from '../../tools/mapping/mapper';
import { MeasureMassifEntity } from '../entity';
import type { AppDB } from '../db';

export class MeasureMassifRepository {
    constructor(private readonly database: AppDB) {}


    async getMeasureMassifById(id: number) {
        return await this.database.measureMassif.where('Id').equals(id).first(async mme => {
            const me = mapper.map(mme, MeasureMassifEntity, MeasureMassif);
            return me;
        });
    }

    async getMeasureMassifEntityByCode(code: string) {
        return await this.database.measureMassif.where('Code').equals(code).first(async mme => {
            return mme;
        });
    }

    async getMeasureMassifByCode(code: string) {
        return await this.database.measureMassif.where('Code').equals(code).first(async mme => {
            const me = mapper.map(mme, MeasureMassifEntity, MeasureMassif);
            return me;
        });
    }

    async attachMeasureMassif(measure: MeasureMassif, interventionId: number) {
        let massifId: number;
        const mme = mapper.map(measure, MeasureMassif, MeasureMassifEntity);

        const ie = await this.database.getInterventionEntityById(interventionId);
        massifId = await this.database.measureMassif.add(mme);
        await this.database.interventions.update(interventionId, {
            MassifIds: ie?.MassifIds ? [...ie.MassifIds, massifId] : [massifId]
        });

        return massifId;
    }

    async updateMeasureMassif(measure: MeasureMassif) {

        const mme = await this.database.getMeasureMassifEntityByCode(measure.Code);
        if (!mme || !mme.Id) {
            return false;
        }
        mapper.mutate(measure, mme, MeasureMassif, MeasureMassifEntity);
        await this.database.measureMassif.update(mme.Id, mme);

        return true;
    }

    async cancelMeasureMassif(measure: MeasureMassif, reason: string) {
        const mme = await this.database.getMeasureMassifEntityByCode(measure.Code);
        if (!mme || !mme.Id) {
            return;
        }

        await this.database.measureMassif.update(mme.Id, { IsCancelled: true, Observation: reason });
        return true;
    }
}
